module.exports = __webpack_public_path__ + "img/chevron-down-bold-red.73c00d71.svg";